import React from "react";
import { AgentReviewDashboard } from "@/components/ops/agent-review/AgentReviewDashboard";

export interface OsAgentReviewWindowContentProps {
  /** Window params from `parseUrlToWindowConfig` / `openWindow` */
  params: Record<string, string>;
}

/**
 * Routes ops-agent-review window state to the queue or an open case based on
 * OS window params (`runId`).
 *
 * @see {@link ../../../../docs/os-aware-navigation.md}
 */
export function OsAgentReviewWindowContent({ params }: OsAgentReviewWindowContentProps) {
  const { runId } = params;
  return <AgentReviewDashboard windowRunId={runId} />;
}
